/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block;margin-right:4px;margin-bottom:4px}.event-badge[_ngcontent-%COMP%]{display:flex;padding:10px;background:#545859;border-radius:6px;color:#fff}.event-badge__icon[_ngcontent-%COMP%]{width:16px;margin-right:6px}.event-badge__text[_ngcontent-%COMP%]{font-size:13px}"];
export { styles as styles };
